import { EMPTY_FIELD } from 'constants/emptyField';

import get from 'lodash/get';
import { RaRecord } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';

export type CurrencyFieldProps = {
  label?: string | React.ReactElement;
  alphaCodeSource: string;
  nameSource: string;
} & Omit<FunctionFieldProps, 'render'>;

export const CurrencyField: React.FC<CurrencyFieldProps> = ({
  label,
  alphaCodeSource,
  nameSource,
  ...rest
}) => {
  return (
    <FunctionField
      label={label}
      render={(record: RaRecord) => {
        const alphaCode = get(record, alphaCodeSource);
        const name = get(record, nameSource);
        if (!alphaCode || !name) {
          return EMPTY_FIELD;
        }

        return (
          <Stack>
            <Typography fontWeight={500} variant="body2">
              {alphaCode}
            </Typography>
            <Tooltip title={name}>
              <Typography
                color="secondary.main"
                sx={{ textWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                variant="body2"
              >
                {name}
              </Typography>
            </Tooltip>
          </Stack>
        );
      }}
      {...rest}
    />
  );
};
